import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconCheck from 'components/icons/IconCheck';
import IconStarOutline from 'components/icons/IconStarOutline';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import Button from 'components/common/Button';

import hexToRgb from 'styles/hexToRgb';
import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  sectionBody: {
    padding: '60px 80px',
    [theme.breakpoints.down('md')]: {
      padding: '40px 24px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px 0',
    },
  },
  typographySubtitle: {
    marginBottom: 24,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      margin: '0 16px 0 16px',
    },
  },
  gridHeader: {
    marginTop: 0,
    marginBottom: 0,
    [theme.breakpoints.down('xs')]: {
      width: '100%!important',
      margin: 0,
    },
    '& $gridItemRecommended': {
      [theme.breakpoints.down('xs')]: {
        marginTop: 53,
      },
    },
  },
  gridItemPlan: {
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px!important',
      width: '100%!important',
      margin: '24px 0 0 0',
      borderBottom: `1px solid ${theme.palette.primary.A100}`,
    },
  },
  gridService: {
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    marginTop: 0,
    marginBottom: 0,
    [theme.breakpoints.down('xs')]: {
      marginTop: 24,
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 0,
      paddingRight: 0,
      width: '100%!important',
    },
  },
  gridServiceItemLabel: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '8px!important',
    },
  },
  gridServiceItemLabelMobile: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '8px!important',
  },
  gridServiceItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '66.66%!important',
    },
  },
  gridItemRecommended: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.20)`,
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
    },
  },
  price: {
    fontSize: pxToRem(26),
  },
  buttonSelect: {
    display: 'block',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 200,
      margin: '0 auto 12px',
    },
  },
  typographyRecommended: {
    fontSize: pxToRem(12),
    backgroundColor: theme.palette.notification[900],
    color: theme.palette.common.white,
    padding: '6px 0',
    margin: '0 12px 0 12px',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    verticalAlign: 'middle',
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      top: -29,
      left: 12,
      right: 12,
      margin: 0,
    },
  },
  iconStarOutline: {
    width: 14,
    height: 14,
    verticalAlign: 'middle',
    margin: '-2px 4px 0 0',
  },
  iconCheck: {
    width: 12,
    height: 12,
    padding: 4,
    color: theme.palette.primary[500],
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.20)`,
    borderRadius: '50%',
  },
  typographyService: {
    marginTop: 4,
    marginBottom: 4,
  },
  typographyServiceValue: {
    marginTop: 4,
    marginBottom: 4,
  },
});

const PaymentPlans = ({ width, paymentPlans, onSelect, classes }) => {
    const servicesList = paymentPlans.reduce((accumulator, currentValue) => {
      let newAccumulator = accumulator;
      currentValue['Full Description'].forEach(item => {
        const itemLabel = item.split(':')[0];
        if (accumulator.indexOf(itemLabel) === -1) {
          newAccumulator = [
            ...newAccumulator,
            itemLabel,
          ];
        }
      });
      return newAccumulator;
    }, []);
    return (
      <Section>
        <SectionHeader fixed>
          <SectionTitle>
            Step 1: Select Payment Plan
          </SectionTitle>
        </SectionHeader>
        <SectionBody className={classes.sectionBody}>
          <Typography className={classes.typographySubtitle} color="secondary" gutterBottom>
            DME4DME is the most efficient and intuitive Business Management Software
            design and developed specifically for the DMEOP Providers.
          </Typography>
          {width !== 'xs' && (
            <Grid
              container
              spacing={24}
              justify="flex-end"
              direction="row"
            >
              {paymentPlans.map(item => (
                <Grid
                  item
                  style={{
                    width: `${75/paymentPlans.length}%`,
                  }}
                  key={item['Stripe Price'].ID}
                >
                  {item['Is Recommended'] &&
                    <Typography
                      className={classes.typographyRecommended}
                      align="center"
                    >
                      <IconStarOutline className={classes.iconStarOutline} />
                      Most Popular
                    </Typography>
                  }
                </Grid>             
              ))}
            </Grid>
          )}
          <Grid
            className={classes.gridHeader}
            container
            spacing={24}
            justify="flex-end"
            direction="row"
          >
            {paymentPlans.map(item => (
              <Grid
                className={classNames(classes.gridItemPlan, {
                  [classes.gridItemRecommended]: item['Is Recommended'],
                })}
                item
                style={{
                  width: `${75/paymentPlans.length}%`,
                }}
                key={item['Stripe Price'].ID}
              >
                {(width === 'xs' && item['Is Recommended']) &&
                  <Typography
                    className={classes.typographyRecommended}
                    align="center"
                  >
                    <IconStarOutline className={classes.iconStarOutline} />
                    Most Popular
                  </Typography>
                }
                <Typography align="center" variant="title" gutterBottom>
                  {item.Name}
                </Typography>
                <Typography align="center" gutterBottom>
                  {item.Description}
                </Typography>
                {(width === 'xs' && !item['Is Fake']) && (
                  <Fragment>
                    <Typography className={classes.price} align="center" gutterBottom >
                      {item['Stripe Price']['Unit Amount'] !== 0 ? `$${item['Stripe Price']['Unit Amount']}` : 'Free'}
                    </Typography>
                    <Button
                      className={classes.buttonSelect}
                      onClick={() => onSelect({
                        'Price ID': item['Stripe Price'].ID,
                        'Unit Amount': item['Stripe Price']['Unit Amount'],
                      })}
                      variant="raised"
                      {...item['Is Recommended'] ? {
                        color: 'primary',
                      } : {}}
                    >
                      Choose
                    </Button>
                  </Fragment>
                )}
              </Grid>             
            ))}
          </Grid>
          {width !== 'xs' && (
            <Grid
              className={classes.gridHeader}
              container
              spacing={24}
              justify="flex-end"
              direction="row"
            >
              {paymentPlans.map(item => (
                <Grid
                  className={classNames({
                    [classes.gridItemRecommended]: item['Is Recommended'],
                  })}
                  item
                  style={{
                    width: `${75/paymentPlans.length}%`,
                  }}
                  key={item['Stripe Price'].ID}
                >
                  {!item['Is Fake'] &&
                    <Fragment>
                      <Typography className={classes.price} align="center" gutterBottom >
                        {item['Stripe Price']['Unit Amount'] !== 0 ? `$${item['Stripe Price']['Unit Amount']}` : 'Free'}
                      </Typography>
                      <Button
                        className={classes.buttonSelect}
                        onClick={() => onSelect({
                          'Price ID': item['Stripe Price'].ID,
                          'Unit Amount': item['Stripe Price']['Unit Amount'],
                        })}
                        variant="raised"
                        {...item['Is Recommended'] ? {
                          color: 'primary',
                        } : {}}
                      >
                        Choose
                      </Button>
                    </Fragment>
                  }
                </Grid>             
              ))}
            </Grid>
          )}
          {servicesList.map(servicesItem => (
            <Grid
              className={classes.gridService}
              key={servicesItem}
              container
              spacing={24}
              alignItems="stretch"
              direction="row"
            >
              <Grid item xs={12} sm={3} className={classes.gridServiceItemLabel}>
                <Typography className={classes.typographyService}>
                  {servicesItem}
                </Typography>
              </Grid>
              {paymentPlans.map((item) => {
                const service = item['Full Description'].find(descriptionItem => descriptionItem.indexOf(servicesItem) !== -1);
                const serviceValue = service ? service.split(':')[1] : null;
                return (
                  <Fragment key={item['Stripe Price'].ID}>
                    {width === 'xs' && (
                      <Grid
                        className={classNames(classes.gridServiceItemLabelMobile, {
                          [classes.gridItemRecommended]: item['Is Recommended'],
                        })}
                        item
                        xs={4}
                      >
                        <Typography variant="caption">
                          {item.Name}
                        </Typography>
                      </Grid>
                    )}
                    <Grid
                      className={classNames(classes.gridServiceItem, {
                        [classes.gridItemRecommended]: item['Is Recommended'],
                      })}
                      item
                      style={{
                        width: `${75/paymentPlans.length}%`,
                      }}
                    >
                      {serviceValue &&
                        <Typography className={classes.typographyServiceValue} align="center">
                          {serviceValue}
                        </Typography>
                      }
                      {(!serviceValue && service) &&
                        <Typography align="center">
                          <IconCheck className={classes.iconCheck} />
                        </Typography>
                      }
                      {(!serviceValue && !service) &&
                        <Typography align="center">
                          &mdash;
                        </Typography>
                      }
                    </Grid>
                  </Fragment>
                );
              })}
            </Grid>
          ))}
        </SectionBody>
      </Section>
    );
  }

PaymentPlans.propTypes = {
  business: PropTypes.shape({
    ID: PropTypes.string,
  }).isRequired,
  paymentPlans: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.string,
  })).isRequired,
  onSelect: PropTypes.func,
  classes: PropTypes.shape({
    sectionBody: PropTypes.string.isRequired,
    buttonSelect: PropTypes.string.isRequired,
    iconCheck: PropTypes.string.isRequired,
  }).isRequired,
};
PaymentPlans.defaultProps = {
  onSelect: () => {},
};

export default withWidth()(withStyles(styles)(PaymentPlans));



// WEBPACK FOOTER //
// ./src/components/settings/PaymentPlans/PaymentPlans.js